import { render, staticRenderFns } from "./TestingTools_writing.vue?vue&type=template&id=002b05be&scoped=true"
import script from "./TestingTools_writing.vue?vue&type=script&lang=js"
export * from "./TestingTools_writing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b05be",
  null
  
)

export default component.exports